import initialstate from '../../initialstate';
import {orderBy} from 'lodash';
import {POST_SNAPSHOTS, GET_ALL_SNAPSHOTS} from '../../../actions/actiontypes';
import {HttpStatusCodes, GAInstructionStatus} from '../../../util/uiconstants';
import normalizeSnapshotList from './normalizeSnapshotList';

export default function groupSnapshotsReducer(state = initialstate.groupAudit.snapshots, action) {
	switch (action.type) {
		case GET_ALL_SNAPSHOTS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const validGAInstructionStatus = [
					GAInstructionStatus.Accepted,
					GAInstructionStatus.Pending,
					GAInstructionStatus.Queued,
					GAInstructionStatus.Sent,
					GAInstructionStatus.Rejected,
					GAInstructionStatus.SystemError,
				];
				const normalizedSnapshots = normalizeSnapshotList(action?.response)?.filter((snap) =>
					validGAInstructionStatus.includes(snap.gaInstructionStatusId)
				);
				return orderBy(normalizedSnapshots, ['sentDate'], ['desc']);
			}

			return state;
		}
		case POST_SNAPSHOTS: {
			if (action.responseObj.status === HttpStatusCodes.Created) {
				return state;
			}
			return state;
		}
	}
}
